import {css} from "@emotion/core";

export const styles = () => {
    return css`
      body {
        background: #524573 url("/images/bg.png");
        background-size: 100px;
      }
`;
}